import { Flex } from "@wayflyer/flyui";

// Used by initial funding application screens on the right hand side panel
export const SecondaryPanelContentLayout = ({ children }: { children: JSX.Element }) => {
  return (
    <Flex direction="column" align="flex-start" justify="space-between" height="100%" width="100%" gap="10">
      {children}
    </Flex>
  );
};
